import { createFileRoute } from '@tanstack/react-router';
import { MyProfilePage } from '../../features/user/pages/MyProfilePage';

export const Route = createFileRoute('/_protected/my-profile')({
  component: MyProfilePage,
});
